// extracted by mini-css-extract-plugin
export default {"navigationBox":"navigationBox_n2haH"};